export function sitesScheduleSelected(state) {
    return state.sitesScheduleSelected.map(function (item){
        return {
            "id": item.id,
            "name": item.label
        }
    })
}

